import { useEffect, useState } from "react";
import { paymentApi } from "../api/paymentApi";
import AdminSidebar from "../components/AdminSidebar";
import Message from "../components/Message";

export default function AdminPayments() {
  const [payments, setPayments] = useState([]);
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    paymentApi.getPayments().then((data) => {
      setPayments(data.payments || []);
    }).catch((error) => setNotice({ type: "error", text: error.message }));
  }, []);

  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1>Payments</h1>
        </div>
        <Message notice={notice} />

        {payments.length > 0 ? (
          <div className="orders-table-container">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Order</th>
                  <th>Customer</th>
                  <th>Method</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {payments.map((payment) => (
                  <tr key={payment.id}>
                    <td>{payment.order_number}</td>
                    <td>{payment.customer_email}</td>
                    <td>{payment.payment_type}</td>
                    <td>${Number(payment.amount).toFixed(2)}</td>
                    <td><span className={`status-badge status-${payment.payment_status}`}>{String(payment.payment_status).toUpperCase()}</span></td>
                    <td>{new Date(payment.payment_date).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No payments found.</p>
        )}
      </div>
    </div>
  );
}
